/* 封装axios用于发送请求 */
import store from '@/store'
import axios from 'axios'
import { Toast } from 'vant'

// 创建一个新的axios实例
const request = axios.create({
  baseURL: 'https://test.smupa.top/api/v1',
  // baseURL: 'http://localhost:8090/api/v1',
  timeout: 1000 * 20 // 请求超时时间
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  Toast.loading({
    message: '请求中...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0
  })
  const token = store.getters.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  const res = response.data
  if (res.status && res.status !== 200) {
    Toast(res.message)
    return Promise.reject(res.message)
  } else {
    Toast.clear()
  }
  // 校验token是否过期
  if (res.status === 401) {
    store.dispatch('user/logout')
  }
  // 对响应数据做点什么
  return res
}, function (error) {
  console.log('请求错误:', error)
  // 对响应错误做点什么
  if (error.response) {
    const err = error.response.data
    if (err.status && err.status !== 200) {
      Toast(err.message)
      // 校验token是否过期
      if (err.status === 401) {
        console.log('token过期')
        store.dispatch('user/logout')
      }
      return Promise.reject(err)
    }
  }
  Toast(error.message)
  return Promise.reject(error)
})

export default request
